import styled from '@emotion/styled';
import { Box, Checkbox } from '@mui/material';
import { NestedCheckboxFormControlLabel, NestedCheckboxGroupWrapper } from './CommonNestedStyles';
import NestedCheckboxLabel from './NestedCheckboxLabel';

export default function NestedOptionCheckbox({
    option,
    state,
    handleParentChange,
    handleSubOptionChange,
}: {
    option: {
        label: string;
        value: string;
        description?: string; // Additional description for each option
        subOptions?: Array<{ label: string; value: string; description?: string }>;
    };
    state: Record<string, boolean>;
    handleParentChange: (parentValue: string, hasSubOptions: boolean) => void;
    handleSubOptionChange: (parentValue: string, subValue: string) => void;
}) {
    return (
        <NestedCheckboxGroupWrapper>
            {/* Parent Option */}
            <NestedCheckboxFormControlLabel
                control={
                    <Checkbox
                        checked={!!state[option.value]}
                        onChange={() => handleParentChange(option.value, !!option.subOptions?.length)}
                        indeterminate={
                            option.subOptions
                                ? option.subOptions.some((sub) => state[sub.value]) &&
                                  !option.subOptions.every((sub) => state[sub.value])
                                : false
                        }
                    />
                }
                label={<NestedCheckboxLabel label={option.label} description={option.description} />}
            />

            {/* Suboptions */}
            {option.subOptions && (
                <>
                    {option.subOptions.map((subOption) => (
                        <SubSection key={subOption.value}>
                            <NestedCheckboxFormControlLabel
                                control={
                                    <Checkbox
                                        checked={state[subOption.value]}
                                        onChange={() => handleSubOptionChange(option.value, subOption.value)}
                                    />
                                }
                                label={
                                    <NestedCheckboxLabel
                                        label={subOption.label}
                                        description={subOption.description}
                                        subOption
                                    />
                                }
                            />
                        </SubSection>
                    ))}
                </>
            )}
        </NestedCheckboxGroupWrapper>
    );
}

const SubSection = styled(Box)`
    margin-left: 2rem;
`;
